export interface FormApiErrorsPayload {
  children?: { [key: string]: string[] };
  global?: string[];
  responseMessage?: string;
  responseDetails?: string;
}

export const FORM_API_VALIDATION_ERROR_KEY = 'apiValidation';



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/forms/form-api-errors.model.ts